import { render, staticRenderFns } from "./figureDialog.vue?vue&type=template&id=3b59d3f5&"
import script from "./figureDialog.vue?vue&type=script&lang=js&"
export * from "./figureDialog.vue?vue&type=script&lang=js&"
import style0 from "./figureDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports